import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { catalogRemoveUerBaseCostGql } from '../catalogUerBaseCostQueries';

const requestId = 'uerRemoveBaseCost';

export const useRemoveUerBaseCost = (uerBaseCostIds: number[], onRemoveSuccess: () => void) => {
    const dispatch = useDispatch();

    const [catalogRemoveReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        catalogRemoveReset(undefined);
        onRemoveSuccess();
    }, [catalogRemoveReset, onRemoveSuccess]);

    const [catalogRemoveData, catalogRemoveStatus, catalogRemoveError, catalogRemoveRequest] = useRequest({
        requestId,
        query: catalogRemoveUerBaseCostGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const catalogRemoveBaseCostRequest = useCallback(() => {
        dispatch(catalogRemoveRequest({ uerBaseCostIds }));
    }, [dispatch, catalogRemoveRequest, uerBaseCostIds]);

    useEffect(() => {
        catalogRemoveReset(undefined);
    }, [catalogRemoveReset]);

    return {
        catalogRemoveBaseCostRequest,
        catalogRemoveData,
        catalogRemoveStatus,
        catalogRemoveError,
    };
};
